import React from 'react';
import styled, { ThemeContext } from 'styled-components';
import { PaddedContainer } from '../common/styles';
import Tile from './tile';

const Container = styled(PaddedContainer)`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding-bottom: 138px;
`;

const Texta = styled.p`
  font-family: ${props => props.theme.fontFamilyBody};
  margin: 0;
`;

const Title = styled(Texta)`
  font-weight: ${props => props.theme.fontWeightHeavy};
  ${props => (props.theme.isMobile ? `
    font-size: 17px;
    line-height: 17px;
  ` : `
    font-size: 20px;
    line-height: 20px;
  `)};
  margin-bottom: 20px;
  text-transform: uppercase;
`;

const Desc = styled(Texta)`
  font-weight: ${props => props.theme.fontWeightBook};
  ${props => (props.theme.isMobile ? `
    font-size: 35px;
    line-height: 36px;
    text-align: center;
  ` : `
    font-size: 40px;
    line-height: 41px;
  `)};
`;

const TileContainer = styled.div`
  display: flex;
  ${props => (props.theme.isMobile ? `
    padding: 0;
    padding-top: 20px;
    flex-direction: column;
    align-items: center;
  ` : `
    padding: 73px 0 14px 0;
    justify-content: center;
  `)};
`;

export default function Investors() {
  const { investors } = React.useContext(ThemeContext);
  const texts = [{
    name: 'chris donohoe',
    says: 'Trending on Livewire is well known to be the first email that brokers and advisors read on the way into work.',
  }, {
    name: 'geoff wilson',
    says: 'Livewire has revolutionised the distribution of high quality financial information in Australia',
  }, {
    name: 'steve johnson',
    says: 'Livewire is a new home for serious investors looking for relevant and informed insights.',
  }];
  const data = investors.map((inv, i) => ({ ...inv, ...(texts[i]) }));

  return (
    <Container>
      <Title>from australian fund managers</Title>
      <Desc>What leading fund managers are saying about Livewire.</Desc>
      <TileContainer>
        {data.map(d => <Tile {...d} key={d.name} />)}
      </TileContainer>
    </Container>
  );
}
